<template lang="pug">
#search
  .main_title.text-center 關鍵搜尋
  img.search_img(src="@/assets/img/icon/search.png")
  .search_bar.d-flex.justify-content-center
    input.input_text_search(type="text", v-model="searchKeyword")
    .search_bar_btn(@click="search") 查詢
  .search_hot.i_mt_6.i_mt_4
    p 熱門搜尋
    a(
      @click="setKeyWord(keyWord.HotKeywordTitle)",
      v-for="(keyWord, index) in hotKeyword.HotKeywordList",
      :key="index"
    ) {{ keyWord.HotKeywordTitle }}

  nav.i_mt_6.i_mlr_auto.i_mt_sm_8(v-if="itemList.length != 0")
    .tabs
      tab(:tab="'全部結果 (' + itemList.length + ')'")
  .container.fade(v-if="itemList.length != 0")
    .item(v-for="(item, index) in itemList", :key="index")
      faq-item.i_mt_8.i_mt_md_4(v-if="item.Type == 'question'", :item="item")
      product-item.i_mt_8.i_mt_md_4(
        v-if="item.Type == 'product'",
        :item="item"
      )
      news-item.i_mt_8.i_mt_md_4(
        v-if="item.Type == 'news' || item.Type == 'announcement'",
        :item="item"
      )
    b-pagination(
      v-model="currentPage",
      :total-rows="totalRows",
      :per-page="perPage",
      first-number,
      last-number
    )
  custom-footer
</template>

<script>
import CustomFooter from "@/components/common/Footer";
import Tab from "@/components/location/Tab";
import MapItem from "@/components/location/Map";
import FaqItem from "@/components/Search/FaqItem";
import ProductItem from "@/components/Search/ProductItem";
import NewsItem from "@/components/Search/NewsItem";
import { getHotKeyword } from "@/json/menu";
import { search } from "@/api/search";

export default {
  name: "Location",
  components: {
    "custom-footer": CustomFooter,
    tab: Tab,
    "map-item": MapItem,
    "faq-item": FaqItem,
    "product-item": ProductItem,
    NewsItem,
    paginationClickable: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    on: {
      resize: function () {
        self.updateSliders();
        this.update();
      },
    },
  },
  data() {
    return {
      totalRows: 0,
      perPage: 5,
      currentPage: 1,
      searchKeyword: "",
      itemList: [],
      hotKeyword: {},
      keyWords: [
        "超額責任險",
        "乙式車險",
        "第三人責任險",
        "意外險",
        "車體險",
        "機車險",
        "丙式車險",
        "旅平險",
      ],
    };
  },
  watch: {},
  created() {
    this.getHotKeyword();
  },
  mounted() {},
  methods: {
    getHotKeyword() {
      getHotKeyword().then((response) => {
        this.hotKeyword = response.data;
      });
    },
    setKeyWord(text) {
      this.searchKeyword = text;
    },
    search() {
      search(this.searchKeyword)
        .then((response) => {
          if (response.data.Status) {
            this.itemList = response.data.Result;
          } else {
            this.itemList = [];
            alert(response.data.Message);
          }
        })
        .catch(() => {
          this.itemList = [];
          alert("伺服器錯誤，請洽管理人員");
        });
    },
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/common/search_bar";
@import "@/assets/style/search/search";

@import "@/assets/style/common/pagination";
</style>
